"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/ban-types */
var react_1 = require("react");
var useCallbackFactory_1 = require("powerhooks/useCallbackFactory");
var runExclusive = __importStar(require("run-exclusive"));
var ThemeProvider_1 = require("./lib/ThemeProvider");
var react_2 = require("react");
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var id_1 = require("tsafe/id");
var assert_1 = require("tsafe/assert");
function createIconButton(params) {
    var _this = this;
    var Icon = (params !== null && params !== void 0 ? params : {
        "Icon": id_1.id(function () { return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, {}, void 0); }),
    }).Icon;
    var IconButton = react_2.memo(react_2.forwardRef(function (props, ref) {
        var className = props.className, iconClassName = props.iconClassName, iconId = props.iconId, size = props.size, _a = props.disabled, disabled = _a === void 0 ? false : _a, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        children = props.children, _b = props.autoFocus, autoFocus = _b === void 0 ? false : _b, tabIndex = props.tabIndex, name = props.name, id = props.id, ariaLabel = props["aria-label"], 
        //For the forwarding, rest should be empty (typewise)
        rest = __rest(props, ["className", "iconClassName", "iconId", "size", "disabled", "children", "autoFocus", "tabIndex", "name", "id", "aria-label"]);
        var _c = __read(react_1.useState(false), 2), isMouseIn = _c[0], setIsMouseIn = _c[1];
        var handleMousePositionFactory = useCallbackFactory_1.useCallbackFactory(runExclusive.build(function (_a) {
            var _b = __read(_a, 1), position = _b[0];
            return __awaiter(_this, void 0, void 0, function () {
                var _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _c = position;
                            switch (_c) {
                                case "in": return [3 /*break*/, 1];
                                case "out": return [3 /*break*/, 2];
                            }
                            return [3 /*break*/, 4];
                        case 1:
                            setIsMouseIn(true);
                            return [2 /*return*/];
                        case 2: return [4 /*yield*/, new Promise(function (resolve) {
                                return setTimeout(resolve, 400);
                            })];
                        case 3:
                            _d.sent();
                            setIsMouseIn(false);
                            _d.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }));
        var _d = useStyles({ disabled: disabled, isMouseIn: isMouseIn }), classes = _d.classes, cx = _d.cx;
        return (jsx_runtime_1.jsx(IconButton_1.default, __assign({ onMouseEnter: handleMousePositionFactory("in"), onMouseLeave: handleMousePositionFactory("out"), ref: ref, className: cx(classes.root, className), disabled: disabled, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : undefined, autoFocus: autoFocus, tabIndex: tabIndex, name: name, id: id }, (function () {
            if ("onClick" in rest) {
                var onClick = rest.onClick, href = rest.href, restRest = __rest(rest, ["onClick", "href"]);
                //For the forwarding, rest should be empty (typewise),
                assert_1.assert();
                return __assign({ onClick: onClick, href: href }, restRest);
            }
            if ("href" in rest) {
                var href = rest.href, _a = rest.doOpenNewTabIfHref, doOpenNewTabIfHref = _a === void 0 ? true : _a, restRest = __rest(rest, ["href", "doOpenNewTabIfHref"]);
                //For the forwarding, rest should be empty (typewise),
                assert_1.assert();
                return __assign({ href: href, "target": doOpenNewTabIfHref
                        ? "_blank"
                        : undefined }, restRest);
            }
            if ("type" in rest) {
                var type = rest.type, restRest = __rest(rest, ["type"]);
                //For the forwarding, rest should be empty (typewise),
                assert_1.assert();
                return __assign({ type: type }, restRest);
            }
        })(), { children: jsx_runtime_1.jsx(Icon, { iconId: iconId, className: cx(classes.icon, iconClassName), size: size }, void 0) }), void 0));
    }));
    var useStyles = ThemeProvider_1.makeStyles({
        "name": { IconButton: IconButton },
    })(function (theme, _a) {
        var disabled = _a.disabled, isMouseIn = _a.isMouseIn;
        return ({
            "root": {
                "padding": theme.spacing(2),
                "&:hover": {
                    "backgroundColor": "unset",
                    "& svg": {
                        "color": theme.colors.useCases.buttons.actionHoverPrimary,
                    },
                },
                //NOTE: If the position of the button is relative (the default)
                //it goes hover everything not positioned, we have to mess with z-index and
                //we don't want that.
                //The relative positioning is needed for the touch ripple effect.
                //If we dont have position relative the effect is not restricted to the
                //button: https://user-images.githubusercontent.com/6702424/157982515-c97dfa81-b09a-4323-beb9-d1e92e7ebe4d.mov
                //The solution is set 'position: relative' only when the ripple effect is supposed to be visible.
                //This explain the following awful rules.
                //The expected result is: https://user-images.githubusercontent.com/6702424/157984062-27e544c3-f86f-47b8-b141-c5f61b8a2880.mov
                "position": isMouseIn ? "relative" : "unset",
                "& .MuiTouchRipple-root": {
                    "display": isMouseIn ? "unset" : "none",
                },
            },
            "icon": {
                "color": theme.colors.useCases.typography[disabled ? "textDisabled" : "textPrimary"],
            },
        });
    });
    return { IconButton: IconButton };
}
exports.createIconButton = createIconButton;
//# sourceMappingURL=IconButton.js.map